<div #appContent>
    <top-navig [displayFilter]="true" [displayLogo]="false" title="Carte" (openFilterEv)="openModal(template)"
        #topnavig></top-navig>
    <div class=" mp-48" [class.mp-97]="ourApp">
        <div class="scrolling-wrapper" #scrollTap>
            <ng-container *ngIf="!router.isActive('/carte/menus',false) || menucategories.length<4">
                <a class="card" [routerLink]="'/carte/menus/'+menucategories[0].slug "
                    [class.activeTab]="router.isActive('/carte/menus/'+menucategories[0].slug,false)"
                    *ngIf="menucategories.length>3">
                    <div>
                        <img class="img" src="assets/images/menus.png" alt="menus">
                    </div>
                    <p>Menus</p>
                </a>
                <ng-container *ngIf="menucategories.length<4">
                    <a class="card" [routerLink]="'/carte/menus/'+menu.slug"
                        *ngFor="let menu of menucategories;let i=index"
                        [class.activeTab]="router.isActive('/carte/menus/'+menu.slug,false)">
                        <div>
                            <img class="img" [src]="menu.avatar|absolutePath :'families'" [alt]="menu.name">
                        </div>
                        <p> {{menu.name}}</p>
                    </a>
                </ng-container>
                <a class="card" [routerLink]="'/carte/famille/'+family.slug" *ngFor="let family of families;let i=index"
                    [class.activeTab]="router.isActive('/carte/famille/'+family.slug,false)">
                    <div>
                        <img class="img" [src]="family.avatar|absolutePath :'families'" [alt]="family.label">
                    </div>
                    <p> {{family.label}}</p>
                </a>
            </ng-container>
            <ng-container *ngIf="router.url.indexOf('menus')!=-1 && menucategories.length>3">
                <a class="card back-card" [routerLink]="'/carte/famille/'+families[0]?.slug">
                    <div>
                        <img class="img" src="assets/images/arrow-menu.png" alt="back">
                    </div>
                    <p>Retour</p>
                </a>
                <a class="card" [routerLink]="'/carte/menus/'+menu.slug" *ngFor="let menu of menucategories;let i=index"
                    [class.activeTab]="router.isActive('/carte/menus/'+menu.slug,false)">
                    <div>
                        <img class="img" [src]="menu.avatar|absolutePath :'families'" [alt]="menu.name">
                    </div>
                    <p> {{menu.name}}</p>
                </a>
            </ng-container>
        </div>
        <router-outlet></router-outlet>
    </div>
    <div *ngIf="siteClose" class="text-center validate">
        <div class="info">
            <p class="box" id="box1">
                {{siteCloseComment}}
            </p>
        </div>
    </div>
</div>
<div class="footer"
    *ngIf="!siteClose && (router.url.indexOf('famille/')>-1 || router.url.indexOf('/offers')>-1 || router.url.indexOf('menus')>-1 || router.url.indexOf('top-des-ventes')>-1 || router.url.indexOf('/filter')>-1)">
    <button class="btn basket" (click)="toBasket()" [class.ical]="animation">
        <img id="basket" src="assets/images/icons/basket.png" width="25px" alt="">
        <span>{{elementsNbr}}</span>
    </button>
</div>
<ng-template #template>
    <div class="modal-header">
        <input #myInput class="search" type="text" placeholder=" Chercher..." (input)="filterComp(myInput.value)">
        <button class="btn-close" (click)="modalRef.hide()">
            <span></span>
            <span></span>
        </button>
    </div>
    <div class="modal-body">
        <label class="container" *ngFor="let c of compositions;let i=index">{{c.text}}
            <input type="checkbox" value="{{c.id}}" [(ngModel)]="c.checked">
            <span class="checkmark"></span>
        </label>
    </div>
    <div class="modal-footer">
        <button class="button-footer" type="button" (click)="search()">
            Valider
        </button>
    </div>
</ng-template>
<ng-template #template2>
    <div class="modal-body text-center">
        <p class="promo"
            style="background-color: #e2e3e5;padding: 5px 10px;border-radius: 3px;border: 2px solid #adaeaf;">
            <img style="margin-right: 10px;width:40px" src="assets/images/megaphone.svg" alt="promo"> Réduction<b>
                {{discount}} %</b> à partir de <b>{{discountFrom}} €</b> d'achats.
        </p>
        <button type="button" class="btn btn-primary btn-template" (click)="decline()">Ok</button>
    </div>
</ng-template>